import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {SearchFormPriceComponent} from "./search-form-price.component";
import {PricePipesModule} from "../../pipes/price/price-pipes.module";
import {PricePipeModule} from "../../pipes/price/price-pipe.module";
import {PermissionModule} from "../../permission/permission.module";

@NgModule({
    imports: [
        CommonModule,
        PricePipesModule,
        PricePipeModule,
        PermissionModule,
    ],
    exports: [
        SearchFormPriceComponent,
    ],
    declarations: [
        SearchFormPriceComponent,
    ],
})
export class SearchFormPriceModule { }
